import {
    Component,
    OnInit,
    OnDestroy,
    Output,
    EventEmitter
} from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { forkJoin } from "rxjs";
import { takeWhile, skip } from "rxjs/operators";
import { TAGSCONSTS } from "../../../../../../constants/tags.constants";
import {
    BreadcrumbService,
    NotificationService,
    BusinessService,
    GlobalValidator,
    TreeService,
    UrlStoreService,
    TabStructureService,
    UserHandlerService
} from "../../../../../../shared/services";
import {
    SetupBusinessStructureStore,
    ConstantStore,
    SetupBusinessInformationStore
} from "../../../../../../store";
import { Chain } from "../../../../../../models";
import { NO_PERMISSION_MSG } from "../../../../../../constants";

@Component({
    selector: "add-edit",
    templateUrl: "./add-edit.component.html",
    styleUrls: ["./add-edit.component.scss"]
})
export class SetupStructureChainComponent implements OnInit, OnDestroy {
    @Output()
    formSubmitted: EventEmitter<boolean> = new EventEmitter<boolean>();
    nodePath: any[] = [];
    businessID: string = "";
    submitting: boolean = false; //For handling form submission
    apiLoading: boolean = false; //For handling API Calls
    edit: boolean = false; //For maintaining if edit mode or not
    loading: boolean = false;
    tag: string;
    chainSetupModel: any = {};
    form: FormGroup; //Required for reactive form validation
    errors: any; //Stores errors returned by server
    noChain: boolean = false;
    serverErrors: any = {}; //Stores errors returned by server
    formErrors = {
        xName: "",
        xSubName: "",
        xTag: "",
        xRefNum: "",
        xStructNum: ""
    };
    alive: boolean = true;
    init: boolean = true;
    params: any;
    numberKey: string = "xStructNum";
    parentMode: boolean = false;
    addressContactValidate: boolean = false;
    bizChangeEvent: boolean = false;
    canEdit = false;
    canAdd = false;
    noPermMsg = NO_PERMISSION_MSG;
    // parentAddress:any=null;
    // parentContact:any=null;
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private breadcrumbService: BreadcrumbService,
        private notificationService: NotificationService,
        public businessService: BusinessService,
        private setupBusinessStructureStore: SetupBusinessStructureStore,
        private fb: FormBuilder,
        private constantStore: ConstantStore,
        private treeService: TreeService,
        public urlStoreService: UrlStoreService,
        private tabStructureService: TabStructureService,
        private setupBusinessInformationStore: SetupBusinessInformationStore,
        public userHandlerService: UserHandlerService
    ) {}

    ngOnInit() {
        this.setPerms();
        this.tabStructureService.checkAndSetTabNameToDef(
            this.tabStructureService.tabMode,
            this.tabStructureService.isCancelClick,
            this.tabStructureService.isSubmitClick
        );
        this.urlStoreService.submitAction = false;
        this.nodePath = this.setupBusinessStructureStore.getNodePath();
        this.businessID = this.businessService.businessID.getValue();
        this.route.params.forEach((params: Params) => {
            this.apiLoading = true;
            this.edit = false;
            this.toFormGroup(new Chain());
            if (params.hasOwnProperty("Id")) {
                this.edit = true;
                if (params.Id === "null") {
                    this.noChain = true;
                } else {
                    //Edit Mode
                    this.loading = true;
                    console.log(
                        "Inside edit mode",
                        this.route,
                        this.treeService.isParent,
                        this.edit
                    );
                    if (
                        !this.treeService.chainID.getValue() &&
                        !this.treeService.isParent
                    ) {
                        console.log("Inside If");
                        this.treeService.setId(params.Id, "chain");
                    }
                    this.fetchChainData(params["Id"]);
                    this.params = params;
                }
            } else {
                // this.setupBusinessInformationStore.get(this.businessService.businessID.getValue())
                // .subscribe((res)=>{
                //     console.log("res", JSON.parse(JSON.stringify(res.data)));
                //     this.parentAddress=res.data.xAddr;
                //     this.parentContact=res.data.xMainContact;
                //     console.log("this.form", JSON.parse(JSON.stringify(this.form.value)));
                //     // if(this.form.controls.xAddr){
                //     //     this.form.controls.xAddr.setValue=this.parentAddress;
                //     // }
                // })
            }
        });
        if (this.tabStructureService.tabMode) {
            this.checkParentMode();
        }
        this.setTabNameNewChain();

        this.setBreadCrumbValue();
        this.setupBusinessStructureStore.watchNodePath$
            .pipe(
                takeWhile(() => this.alive),
                skip(1)
            )
            .subscribe((nodePath: any[]) => {
                console.log("This is updated node path", nodePath);
                this.parentMode = false;
                // this.checkParentMode();
                // this.setTabNameNewChain();
            });
        this.tabStructureService.watchParentFetched$
            .pipe(
                takeWhile(() => this.alive),
                skip(1)
            )
            .subscribe(res => {
                console.log("Here in watcher of parent fetched", res);
                if (res) {
                    console.log("Here in watcher of parent fetched res true");
                    this.setTabNameNewChain();
                }
            });
        this.businessService.watchBusinessID$
            .pipe(
                takeWhile(() => this.alive),
                skip(1)
            )
            .subscribe(bizId => {
                if (bizId) {
                    this.bizChangeEvent = true;
                } else {
                    this.router.navigate([
                        "/dashboard/setup/business/structure/information"
                    ]);
                }
            });
    }

    setTabNameNewChain() {
        if (!this.edit) {
            if (this.tabStructureService.tabLabelItems.length) {
                this.tabStructureService.tabLabelItems.map(labelItem => {
                    if (labelItem.label.includes("Chain")) {
                        if (labelItem.hasOwnProperty("type")) {
                            labelItem["label"] = "Chain";
                            labelItem["type"] = "New";
                            labelItem["name"] = "";
                        }
                    }
                });
                this.tabStructureService.setTabStructureNames(
                    this.tabStructureService.tabLabelItems
                );
            }
        }
    }

    checkParentMode() {
        if (this.tabStructureService.tabLabelItems.length) {
            this.tabStructureService.tabLabelItems.map(labelItem => {
                if (labelItem.label.includes("Chain")) {
                    if (
                        labelItem.hasOwnProperty("type") &&
                        labelItem["type"] === "Parent"
                    ) {
                        this.parentMode = true;
                    } else {
                        this.parentMode = false;
                    }
                }
            });
        }
    }

    fetchChainData(id: string) {
        forkJoin(
            this.setupBusinessStructureStore.get(id)
        ).subscribe(
            (response: any) => {
                this.loading = false;
                this.chainSetupModel = response[0].data;
                // this.parentAddress = JSON.parse(JSON.stringify(response[1].data.xAddr));
                console.log("this.chainForm", this.form);
                this.form.patchValue(new Chain(this.chainSetupModel));
                // this.form.controls.xAddr.setValue(this.parentAddress);
            },
            (error: any) => {
                this.handleErrorResponse(error);
            },
            () => {
                this.apiLoading = false;
            }
        );
    }

    toFormGroup(data: Chain): void {
        console.log("formgroup data", data);
        this.form = this.fb.group({
            xTntTag: [data.xTntTag || "test", []],
            xWall1EntyID: [data.xWall1EntyID || "", []],
            xWall2EntyID: [data.xWall2EntyID || this.businessID, []],
            xTag: [data.xTag || "", []],
            xStatus: [data.xStatus || "1", []],
            xName: [
                data.xName || "",
                [Validators.required, GlobalValidator.validateName]
            ],
            xTypeTag: [
                data.xTypeTag || TAGSCONSTS.structTags.chainTags,
                [
                    /*Validators.required*/
                ]
            ],
            xNotes: [data.xNotes || "", []],
            xRefNum: [
                data.xRefNum || "",
                [
                    /*Validators.required*/
                ]
            ],
            xTZTag: [
                data.xTZTag || "",
                [
                    /*Validators.required*/
                ]
            ],
            xSubName: [
                data.xSubName || "",
                [
                    /*Validators.required*/
                ]
            ],
            // xAddr: this.fb.group(new Address(data.xAddr)),
            // xSocial: this.fb.group(new Social(data.xSocial)),
            // xMainContact: this.fb.group(new MainContact(data.xMainContact)),
            xBusinessID: [data.xBusinessID || this.businessID],
            xStructNum: [data.xStructNum, [Validators.required]]
        });
    }

    setBreadCrumbValue(): void {
        const breadCrumb: any = {};
        breadCrumb.root = "Setup";
        breadCrumb.child = "Business";
        breadCrumb.subChild = "Structure";
        breadCrumb.subChildLink = "setup/business/structure/information";
        breadCrumb.grandChild = "Chain-Setup";
        breadCrumb.rootList = [];
        this.breadcrumbService.setBreadCrumb(breadCrumb);
    }

    onChainSubmit(form: FormGroup): void {
        this.urlStoreService.submitAction = true;
        this.tabStructureService.isSubmitClick = true;
        this.submitting = true;
        this.errors = {}; //Reset Errors
        const chainModel = form.getRawValue();
        console.log("chainmodel", chainModel);
        if (this.edit) {
            //Update chain
            this.setupBusinessStructureStore
                .update(this.chainSetupModel._id, chainModel)
                .subscribe(
                    (response: any) => {
                        this.handleSuccessResponse(response.data, chainModel);
                    },
                    (error: any) => {
                        console.log("error", error);
                        if (
                            error.hasOwnProperty("name") &&
                            error.name === "Conflict"
                        ) {
                        } else {
                            this.serverErrors = error.errors;
                            this.handleError(error);
                        }
                    },
                    () => {}
                );
        } else {
            //Add New chain
            this.setupBusinessStructureStore.store(chainModel).subscribe(
                (response: any) => {
                    this.handleSuccessResponse(response.data, chainModel);
                },
                (error: any) => {
                    console.log("error", error);
                    this.serverErrors = error.errors;
                    this.handleError(error);
                },
                () => {}
            );
        }
    }

    handleSuccessResponse(data?: any, chainModel?: any): void {
        this.submitting = false;
        this.formSubmitted.emit(true);
        const msg = this.edit
            ? "Record Successfully Updated."
            : "Record Successfully Added.";
        this.notificationService.success(msg, "Success!");
        this.businessService.toggleRefreshTree();
        console.log("HERE 1", chainModel);
        // Proper routing depending upon nodeClick or any other click
        if (this.treeService.nodeClick) {
            console.log("HERE 2");
            if (this.edit) {
                this.fetchChainData(data.id);
            } else {
                this.tabStructureService.currentNodeName = chainModel.xName;
                console.log("HERE 3");
                this.urlStoreService.routeToCurrentUrl(data, "chain", "add");
            }
        } else {
            // // this.treeService.setId(this.businessService.businessID.getValue(), "business");
            // this.urlStoreService.routeBackToPreviousUrl();
            console.log(
                "this.urlStoreService.previousUrl",
                this.urlStoreService.previousUrl
            );
            console.log(
                "this.urlStoreService.currentUrl",
                this.urlStoreService.currentUrl
            );
            if (this.tabStructureService.tabMode) {
                this.urlStoreService.routeBackToPreviousUrl();
            } else {
                if (this.tabStructureService.addNodeBtnClick) {
                    this.tabStructureService.currentNodeName = chainModel.xName;
                    this.urlStoreService.routeToCurrentUrl(
                        data,
                        "chain",
                        "add"
                    );
                } else {
                    this.treeService.setId(
                        this.businessService.businessID.getValue(),
                        "business"
                    );
                    console.log(
                        "onCancel  chain",
                        this.treeService.businessID.getValue(),
                        this.treeService.chainID.getValue()
                    );
                    this.urlStoreService.routeBackToPreviousUrl();
                }
            }
        }
    }

    handleErrorResponse(error: any): void {
        this.submitting = false;
        this.errors = JSON.parse(error._body).errors;
        this.notificationService.error(
            JSON.parse(error._body).name === "BadRequest"
                ? "Record Not Added"
                : JSON.parse(error._body).name,
            JSON.parse(error._body).message === "Invalid data"
                ? "Please fill all Required Details"
                : JSON.parse(error._body).message
        );
    }

    handleError(error: any): void {
        this.submitting = false;
        this.formSubmitted.emit(true);
        console.log("error inside handler", error);
        for (const field of Object.keys(error.errors)) {
            if (this.formErrors.hasOwnProperty(field)) {
                if (field === "xStructNum") {
                    console.log("Inside handle error", error);
                    if (error.name === "Conflict") {
                        let err = error.errors.xStructNum.replace(
                            /struct/g,
                            "Chain"
                        );
                        this.notificationService.error(err, "Conflict");
                        this.clearErrors("xStructNum");
                    } else {
                        this.formErrors[field] =
                            "Field is not allowed to be empty";
                    }
                } else {
                    this.formErrors[field] = "Field is not allowed to be empty";
                }
            }
            if (field === "xRefNum") {
                console.log("Inside reference number handle error", error);
                if (error.name === "Conflict") {
                    let err = error.errors.xRefNum.replace(/struct/g, "Chain");
                    this.notificationService.error(err, "Conflict");
                    this.clearErrors("xRefNum");
                }
            }
        }
    }

    onCancel(event: Event) {
        event.preventDefault();
        console.log("onCancel", this.treeService.chainID.getValue());
        console.log(
            "this.urlStoreService.secondLastUrl",
            this.urlStoreService.secondLastUrl
        );
        console.log(
            "this.urlStoreService.previousUrl",
            this.urlStoreService.previousUrl
        );
        console.log(
            "this.urlStoreService.currentUrl",
            this.urlStoreService.currentUrl
        );

        if (this.tabStructureService.tabMode) {
            console.log(
                "tabmode",
                this.edit,
                this.tabStructureService.previousTabStructureLabel
            );
            if (!this.edit) {
                this.urlStoreService.routeBackToPreviousUrl();
            } else {
                this.tabStructureService.defaultTabStructureLabel = this.tabStructureService.previousTabStructureLabel;
                this.urlStoreService.routeToSecondLastUrl();
            }
        } else {
            console.log("no tabmode");
            if (this.edit) {
                console.log("no tabmode and edit");
                if (!this.tabStructureService.editMode) {
                    console.log("no tabmode and edit and editmode");
                    this.tabStructureService.defaultTabStructureLabel = this.tabStructureService.previousTabStructureLabel;
                    if (
                        this.urlStoreService.previousUrl &&
                        !this.urlStoreService.previousUrl.includes("add-edit")
                    ) {
                        this.treeService.setId(
                            this.treeService.previousSelectedNode.id,
                            this.treeService.previousSelectedNode.type
                        );
                    }
                    this.urlStoreService.routeBackToPreviousUrl();
                    // }
                } else {
                    console.log("no tabmode and edit and no editmode");
                    if (this.treeService.nodeClick) {
                        this.urlStoreService.routeToSecondLastUrl();
                    } else {
                        // this.treeService.setId(null, 'store');
                        console.log(
                            "id and type of previous selected node",
                            this.treeService.previousSelectedNode.id,
                            this.treeService.previousSelectedNode.type
                        );
                        this.treeService.setId(
                            this.treeService.previousSelectedNode.id,
                            this.treeService.previousSelectedNode.type
                        );
                        this.urlStoreService.routeBackToPreviousUrl();
                    }
                }
            } else {
                console.log("no tabmode and no edit");
                this.urlStoreService.routeBackToPreviousUrl();
            }
        }
    }

    onEditClick(event: Event) {
        console.log(
            "Here onEditClick function in biz===>",
            this.parentMode,
            JSON.parse(
                JSON.stringify(
                    this.tabStructureService.defaultTabStructureLabel
                )
            )
        );
        this.tabStructureService.previousTabStructureLabel = JSON.parse(
            JSON.stringify(this.tabStructureService.defaultTabStructureLabel)
        );
        this.treeService.isParent = false;
        this.parentMode = false;
        this.edit = true;
        this.treeService.setId(this.chainSetupModel._id, "chain");
        // this.router.navigate(['dashboard/setup/business/structure/information'])
    }

    clearErrors(errorName: string): void {
        console.log("here", errorName);
        if (this.serverErrors[errorName]) {
            console.log("here", this.serverErrors);
            delete this.serverErrors[errorName];
        }
    }

    onKeypress(event: any) {
        GlobalValidator.phoneNumberFormat(event);
    }

    onPaste(event: any) {
        GlobalValidator.phoneNumberFormat(event);
    }

    ngOnDestroy() {
        this.alive = false;
    }

    setPerms(){
        this.canEdit = this.userHandlerService.userPerms.canEditSetup;
        this.canAdd = this.userHandlerService.userPerms.canCreateSetup;
    }
}
